import Vue from 'vue';
import VueRouter from 'vue-router';
import VueHead from 'vue-head';
import routes from './routes';
import App from './App';

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
});

Vue.use(VueRouter);
Vue.use(VueHead, {
  inner: 'Sound design and field recording',
  separator: '-',
  complement: 'Rick Blything',
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js